import Swal from "sweetalert2";

const destroyUtils = {
  simpleDestroy: async (text = "", title = "Excluir") => await Swal.fire({
    icon: 'warning',
    title: title,
    text: text,
    confirmButtonText: "Sim",
    confirmButtonColor: "#063A6C",
    cancelButtonText: "Não",
    cancelButtonColor: "#c10007",
    showCancelButton: true,
    reverseButtons: true
  }),

  keywordDestroy: async (operation, keyword, title = "Atenção") => {
    const result = await Swal.fire({
      icon: "warning",
      title: title,
      showCancelButton: true,
      html: `${operation}<br>Para confirmar, digite <b>${keyword}</b> abaixo:`,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: '#063A6C',
      input: "text",
      reverseButtons: true,
      preConfirm(inputValue) {
        if (inputValue.trim() !== keyword) {
          Swal.showValidationMessage(`Digite corretamente a palavra-chave`);
        }
      }
    });

    return result.isConfirmed;
  }
}

export default destroyUtils;